import type React from 'react';

import { Text } from '@change/ds-core-ui';

import type { QrCodeType } from '@change-corgi/middle-end-gql-schema';

import { PetitionQRCode } from '#src/app/shared/components/qrcode';

import { QRCodeDownloadLink } from './QRCodeDownloadLink';

export const QRCodeDownload: React.FC<{
	slugOrId: string;
	displaySize: number;
	displayType: QrCodeType;
	downloadType: QrCodeType;
	downloadSize?: number;
	descriptionText: string;
	downloadLinkText: string;
	downloadFilename?: string;
	onClick?: (data: { shareId: string | null | undefined }) => Promise<void>;
}> = ({
	slugOrId,
	displaySize,
	displayType,
	downloadSize,
	downloadType,
	descriptionText,
	downloadLinkText,
	downloadFilename,
	onClick,
}) => {
	return (
		<div className="border-stroke-weaker flex flex-col gap-4 rounded-md border border-solid p-4">
			<div className="flex justify-center gap-2">
				<div className="h-20 min-h-20 w-20 min-w-20">
					<PetitionQRCode slugOrId={slugOrId} size={displaySize} type={displayType} className="shrink-0" />
				</div>
				<Text variant="body" size="medium">
					{descriptionText}
				</Text>
			</div>

			<div className="flex flex-col gap-2">
				{/* eslint-disable-next-line @change-corgi/require-data-qa-attribute */}
				<QRCodeDownloadLink
					slugOrId={slugOrId}
					size={downloadSize}
					type={downloadType}
					onClick={onClick}
					filename={downloadFilename}
				>
					{downloadLinkText}
				</QRCodeDownloadLink>
			</div>
		</div>
	);
};
